module.exports = __webpack_public_path__ + "img/google_c.648fa9fa.svg";